// extracted by mini-css-extract-plugin
module.exports = {"roomImageContainer":"styles_roomImageContainer__VjBsU","roomImage":"styles_roomImage__S8juh","roomImagesNumber":"styles_roomImagesNumber__MSLnB system_captionL__sBgtx"};